import React from "react";
import "./styles.scss";
import verifyTick from "../../assets/multibank/verifyTick.png";
import information from "../../assets/multibank/information.png";
import x from "../../assets/x.png";
const ConditionalInput = ({
  icon,
  iconStatus = false,
  label,
  disabled,
  onIconPress = () => {},
  style,
  inputType = "input",
  onEnter,
  ...inputProps
}) => {
  const Component = inputType;
  // console.log("accoafasf",accountIcon);
  return (
    <React.Fragment>
      {!!label && <label className="inputLabel2">{label}</label>}
      <div
        className={"inputContainer2"}
        style={disabled ? { background: `#e8e8e8` } : {}}
      >
        {icon && (
          <div className="inputContainer2__icon">
            <img src={icon} alt="inputIcon" width="18px" height="18px" />
          </div>
        )}
        <Component
          style={style}
          disabled={disabled}
          {...inputProps}
          {...(inputProps?.type === "number"
            ? {
                onKeyDown: (e) => {
                  if (e.keyCode == 13 && onEnter) {
                    onEnter();
                  }
                  if (
                    e.key === "ArrowUp" ||
                    e.key === "ArrowDown" ||
                    e.key === "-" ||
                    e.key === "e" ||
                    e.key === "E" ||
                    e.key === "+" ||
                    e.key === "."
                  )
                    e.preventDefault();
                },
              }
            : {
                onKeyDown: (e) => {
                  if (e.key === "Enter") {
                    onEnter();
                  }
                },
              })}
        />
        {iconStatus && (
          <div onClick={onIconPress} className="inputContainer2__icon1">
            <img src={x} alt="inputIcon" width="18px" height="18px" />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default ConditionalInput;
